import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoFlexAlignStart,
    RaikoGridOneColumn, RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {chartColors} from "../../../component/charts/utils/ChartColors";
import PieChartWithPaddingAngle, {
    preparePieChartItem
} from "../../../component/charts/pieChartWithPaddingAngle/PieChartWithPaddingAngle";
import PieChartLineInfo from "../../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";
import {css} from "@emotion/css";
import "./HabitationMonitoringPieChartHostCapacities.scss"
import RaikoSegmentSelect, {
    raikoSegmentSelectItemGenerator,
} from "../../../raikoComponents/raikoSegmentSelect/RaikoSegmentSelect";

export default function HabitationMonitoringPieChartHostCapacities({periodId, refreshFlag = false}) {


    const service = new HabitationMonitoringService()


    const [hostCapacitiesData, setHostCapacitiesData] = useState({})
    const [hostCapacitiesFilters, setHostCapacitiesFilters] = useState([
        raikoCustomSelectItemGenerator("COUPLE", "مجموع"),
        raikoCustomSelectItemGenerator("MAN", "بررسی خودکار"),
    ])
    const [selectedHostCapacities, setSelectedHostCapacities] = useState(hostCapacitiesFilters[0].id)

    function prepareHostCapacitiesChartItems(total, men, women) {
        return [
            preparePieChartItem('آقا', men, chartColors.blue),
            preparePieChartItem('خانم', women, chartColors.red),
        ]
    }

    function getDataFromServer() {
        service.getHostCapacities(periodId)
            .then(response => {
                setHostCapacitiesData({
                    COUPLE: prepareHostCapacitiesChartItems(
                        response.totalPeopleCapacity,
                        response.totalMenCapacity,
                        response.totalWomenCapacity
                    )
                    ,
                    MAN: prepareHostCapacitiesChartItems(
                        response.totalPeopleCapacityOfAutomaticAcceptation,
                        response.totalMenCapacityOfAcceptation,
                        response.totalWomenCapacityOfAcceptation
                    ),
                    WOMAN: prepareHostCapacitiesChartItems(
                        response.totalPeopleCapacityOfAutomaticAcceptation,
                        response.totalMenCapacityOfAutomaticAcceptation,
                        response.totalWomenCapacityOfAutomaticAcceptation
                    )
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return <>
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoFlexAlignStart className={css`align-items: center;`}>
                    <RaikoLabel
                        text={"ظرفیت ها"}
                        className={css`
                            white-space: nowrap;
                            flex-grow: 20;
                            width: 200%;`}
                    />
                    <RaikoSegmentSelect
                        value={selectedHostCapacities}
                        setValue={setSelectedHostCapacities}
                        items={[
                            raikoSegmentSelectItemGenerator("COUPLE", "مجموع"),
                            raikoSegmentSelectItemGenerator("MAN", "بررسی خودکار"),
                        ]}
                    />
                    {/*<RaikoCustomSelect*/}
                    {/*    labelText={"فیلتر"}*/}
                    {/*    value={selectedHostCapacities}*/}
                    {/*    setValue={setSelectedHostCapacities}*/}
                    {/*    items={hostCapacitiesFilters}*/}
                    {/*/>*/}
                </RaikoFlexAlignStart>
                <div className={"horizontalPieChartContainer"}>
                    <PieChartWithPaddingAngle
                        data={hostCapacitiesData[selectedHostCapacities]}
                    />
                    <div className={"horizontalPieChartLineInfoContainer"}>
                        {hostCapacitiesData && hostCapacitiesData[selectedHostCapacities] ?
                            hostCapacitiesData[selectedHostCapacities].map((item, index) => {
                                return <PieChartLineInfo
                                    color={item.color}
                                    value={item.value}
                                    title={item.label}
                                />
                            }) : ""}
                    </div>
                </div>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    </>


}